module.exports = "https://static.wmbcdn.com/uniweb/images/4d2c3d056c2ae80ffb9ff6b92b32941e.svg";